class RedemptionGrid {
	constructor() {		
	}
	renderProductRedemption(redemptions) {
		redemptions.forEach((redemption) => {
			
			if (redemption.discountType === "product") { 
             console.log(redemption)
				$(".loyalty-product-redemptions").append(
					$("<a>", {
						"data-variant-id" : redemption.appliesToId
                     

					}).addClass("loyalty-redemption-prod-container").append(
						$("<div>").addClass("loyalty-redemption-img-container").append(
						$("<img>", {
							"src" : redemption.backgroundImageUrl
						})
						),
                        $("<div>").addClass("loyalty-redemption-product-price").text(redemption.costText),
                        $("<h3>").addClass("loyalty-redemption-prod-name").text(redemption.name),
						$("<div>", {
						"data-variant-id" : redemption.appliesToId,
                         
						 "data-confirm-btn-text":"Yes, redeem"
                        }).addClass("loyalty-buy-product-btn swell-buy-product-btn").text("redeem now")
							
					)
					)
				
			} 
		});
		$("a.swell-buy-product-btn").click(()=> {
			return false;
		});
   
		this.makeRedemptionSlick();
     

	}
  
  checkLoggedIn(customer) {
   if (customer.created_at === undefined) { 
    	 $(".loyalty-buy-product-btn").addClass("hide")
   }
  
  }
  
  makeRedemptionSlick() {
      console.log("makeRedemptionSlick is running")
    var newscript = document.createElement('script');
         newscript.type = 'text/javascript';
         newscript.async = true;
         newscript.src = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
      (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild(newscript);
      
      setTimeout(function(){
      $('.loyalty-product-redemptions').slick({
                  infinite: true,
                   slidesToShow: 5,
                   slidesToScroll: 1,
                   arrows: true,
         nextArrow: '<i class="loyalty-slick-next">❯</i>',
prevArrow: '<i class="loyalty-slick-prev">❮</i>',
                    responsive: [
              {
                breakpoint: 769, settings: {slidesToShow: 3, slidesToScroll: 1, dots: true, centerMode: false,
                     infinite: true, centerPadding: '40px',  arrows: false}
              },
              {
                breakpoint: 480, settings: {slidesToShow: 1, slidesToScroll: 1, dots: true, centerMode: true,
                    infinite: true, centerPadding: '40px',  arrows: false}
              }
           ]
            });
        }, 1000);
}


}


// class RedemptionGrid {
// 	constructor() {
		
		
// 	}


// 		renderProductRedemption(redemptions) {
		
// 		redemptions.forEach((redemption) => {
			
// 			if (redemption.discountType === "product") { 
             
// 				$(".loyalty-product-redemptions").append(
// 					$("<a>", {
// 						"data-variant-id" : redemption.appliesToId

// 					}).addClass("loyalty-redemption-prod-container").append(
// 						$("<div>").addClass("loyalty-redemption-img-container").append(
// 						$("<img>", {
// 							"src" : redemption.backgroundImageUrl
// 						})

// 						),
// 						$("<h3>").addClass("loyalty-redemption-prod-name").text(redemption.name),
// 						$("<div>").addClass("loyalty-redemption-product-desc").text(redemption.description),
// 						$("<div>").addClass("loyalty-redemption-product-price").text(redemption.costText),
// 						$("<div>", {
// 						"data-variant-id" : redemption.appliesToId
// 					}).addClass("loyalty-buy-product-btn swell-buy-product-btn").text("redeem now")
							
// 					)
// 					)
				
// 			} 
// 		});
// 		$("a.swell-buy-product-btn").click(()=> {
// 			return false;;
// 		});
      	
// 		this.makeRedemptionSlick();

// 	}
  
  


  
//   checkLoggedIn(customer) {
//    if (customer.created_at === undefined) { 
//      console.log(customer);
//     	 $(".loyalty-buy-product-btn").addClass("hide")
//    }
  
//   }
  
// 		makeRedemptionSlick() {
// 		var newscript = document.createElement('script');
// 		     newscript.type = 'text/javascript';
// 		     newscript.async = true;
// 		     newscript.src = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
// 		  (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild(newscript);
		  
// 		  setTimeout(function(){
// 		  $('.loyalty-product-redemptions').slick({
//  					 infinite: true,
//   					 slidesToShow: 4,
//   					 slidesToScroll: 1,
//   					 arrows: true,
//              nextArrow: '<i class="loyalty-slick-next">❯</i>',
//   prevArrow: '<i class="loyalty-slick-prev">❮</i>',
//   					  responsive: [
// 		          {
//                     breakpoint: 769, settings: {slidesToShow: 2, slidesToScroll: 1, dots: true, arrows: false}
// 		          }
// 		       ]
// 				});
// 		    }, 1000);
// 	}


// }






